export default __webpack_public_path__ + "static/media/75.cf2dfd21.png";